var inputFocus = {
  input: '.form-click',
  wrapper: '.form-wrapper',
  parent: '.form-focus',
  addClassParent: 'focus',
  addClassWrapper: 'display-on'
}

$(function () {
  $(document).on('click', function (evt) {
    var email = $(inputFocus.input);

    if ($(evt.target).parents(inputFocus.parent).length || $(evt.target).parents(inputFocus.wrapper).length) {
      $(evt.target).parents(inputFocus.parent).addClass(inputFocus.addClassParent);
      $(evt.target).parents(inputFocus.wrapper).addClass(inputFocus.addClassWrapper);
      email.attr("placeholder", email.attr('data-placeholder'));

      if ($(evt.target).parents(inputFocus.wrapper).length) {
        email.focus();
      }
    } else {
      $(inputFocus.parent).removeClass(inputFocus.addClassParent);
      $(inputFocus.wrapper).removeClass(inputFocus.addClassWrapper);
    }
  });

  document.querySelectorAll('.password-input-container').forEach(passwordContainer => {
    const input = passwordContainer.querySelector('input');
    const button = passwordContainer.querySelector('.visibility-switch');

    button.addEventListener('click', () => {
      if (input.getAttribute('type') === 'text') {
        input.setAttribute('type', 'password');
      } else {
        input.setAttribute('type', 'text');
      }
    });
  });
});
